module.exports = __webpack_public_path__ + "img/4dfc664.svg";